module.exports = __webpack_public_path__ + "static/media/black_user_welcome.576d0b96.png";